import { TWidgetState } from './models'

export const FEATURE_NAME = 'widgets'

/* The room a partner page widget holds while it loads: about the height of a row of widgets. */
export const PARTNER_WIDGET_LOADING_HEIGHT = 400

export enum WidgetName {
  PartnerDashboardPanel = 'PartnerDashboardPanel',
}

export enum WidgetStatus {
  None = 'none',
  Ready = 'ready',
  Loading = 'loading',
  Hidden = 'hidden',
  Failed = 'failed',
}

export const initialState: TWidgetState = {
  [WidgetName.PartnerDashboardPanel]: {
    name: WidgetName.PartnerDashboardPanel,
    status: WidgetStatus.None,
  },
}
